var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('crud-form',_vm._b({attrs:{"submitText":"Guardar"},on:{"calculate":_vm.calculate,"submitForm":function($event){_vm.submitForm($event)},"reset":_vm.resetForm}},'crud-form',_vm.formProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }